import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useState } from 'react';
import { Button } from 'semantic-ui-react';
import { navigate } from 'gatsby';
import _isEmpty from 'lodash/isEmpty';
import { createCheckoutPath } from './CartActionButton.utils';
import CartActionNotification from './components/CartActionNotification';
import { CartContext } from '../../contexts/CartContext';
import { startCheckout } from '../../utils/api';
import { ActionName } from '../RecaptchaProvider/RecaptchaProvider.constants';
import { useRecaptcha } from '../RecaptchaProvider/RecaptchaProvider.hooks';
import './CartActionButton.css';
var defaultProps = {
  onClick: null,
  className: '',
  showIfNoItems: false,
  show: true,
  loading: false,
  button: null,
  showNotifications: false
};
export default function CartActionButton(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    showIfNoItems = _ref.showIfNoItems,
    show = _ref.show,
    loadingProp = _ref.loading,
    button = _ref.button,
    showNotifications = _ref.showNotifications;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    executeRecaptcha = _useRecaptcha2[0],
    recaptchaLoaded = _useRecaptcha2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useContext = useContext(CartContext),
    cart = _useContext.cart;
  if (!recaptchaLoaded) {
    return null;
  }
  var order = cart.order,
    orderId = cart.orderId,
    notifications = cart.notifications,
    clearNotifications = cart.clearNotifications,
    sessionToken = cart.orderSessionToken;
  var _order$line_items = order.line_items,
    lineItems = _order$line_items === void 0 ? [] : _order$line_items,
    subTotal = order.sub_total;
  function handleOnClick() {
    return _handleOnClick.apply(this, arguments);
  }
  function _handleOnClick() {
    _handleOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var recaptchaToken, checkout, checkoutId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            if (!onClick) {
              _context.next = 6;
              break;
            }
            _context.next = 5;
            return onClick();
          case 5:
            return _context.abrupt("return");
          case 6:
            _context.next = 8;
            return executeRecaptcha(ActionName.START_ORDER_CHECKOUT);
          case 8:
            recaptchaToken = _context.sent;
            _context.next = 11;
            return startCheckout(orderId, recaptchaToken, sessionToken);
          case 11:
            checkout = _context.sent;
            checkoutId = checkout.uuid;
            navigate(createCheckoutPath(orderId, checkoutId));
          case 14:
            _context.prev = 14;
            setLoading(false);
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0,, 14, 17]]);
    }));
    return _handleOnClick.apply(this, arguments);
  }
  if (_isEmpty(cart) || !show) {
    return null;
  }
  var amountOfItems = lineItems.length;
  if (amountOfItems === 0 && !showIfNoItems) {
    return null;
  }
  var defaultButton = /*#__PURE__*/React.createElement(Button, {
    primary: true,
    className: "default-checkout-button"
  }, "CHECKOUT - $", subTotal);
  var finalComponent = /*#__PURE__*/React.cloneElement(button || defaultButton, {
    onClick: handleOnClick,
    disabled: loadingProp || loading,
    loading: loadingProp || loading
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "cart-action-button ".concat(className)
  }, /*#__PURE__*/React.createElement(CartActionNotification, {
    trigger: finalComponent,
    message: notifications[0],
    onClose: clearNotifications,
    open: !_isEmpty(notifications) && showNotifications
  }), /*#__PURE__*/React.createElement("div", {
    className: "items-number-container"
  }, amountOfItems));
}
CartActionButton.defaultProps = defaultProps;